import React, { useState, useEffect, useRef } from "react"
import _get from "lodash/get"
import QuantitySelector from "@/components/cart/QuantitySelector"
import { NumericFormat } from "react-number-format"
import { checkStock, getEtaDataIndividual } from "@/utils/helper"
import { getConfig } from "@/constants/config"
import {
  addCartItemSummaryAnalytics,
  addRemoveProductFromCartAnalytics,
} from "@/components/cart/cartAnalytics"
import {
  getPDPUrl,
  pdpTypeFormat,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
import {
  removeCartItem,
  getMessageStatus,
  getInventoryStatus,
  getInventoryErrorMessage,
} from "@/components/cart/cartHelper"
import PartsViewer from "@/components/PartsViewer/v1/PartsViewer"
import Image from "next/image"
import Link from "next/link"
import noImage from "@/public/images/image-missing.png"
import Radio from "@/components/core/Radio/Radio"
import InstallationServiceCart from "@/components/InstallationService/InstallationService"
import { selectCartState } from "@/store/features/cartSlice"
import CartServiceIcon from "@/public/icons/install-service-cart-icon.svg"
import { useDispatch, useSelector } from "react-redux"
import { deliveryOverlayEventInfoAnalytics } from "../checkout/v1/checkoutAnalytics"
import { setCardStatus } from "@/store/features/cartSlice"
import { getChildItemsCount } from "@/components/cart/utils"
import { INSTALL_SERVICES } from "@/utils/constants"
import Checkbox from "@/components/core/Checkbox/Checkbox"

const CartItemTile = props => {
  const {
    data = {},
    checkoutMode,
    i18n,
    isDeliveryOption,
    comboChild,
    qtyLoading,
    loading,
    onQuantityChange,
    orderMode,
    hideAlerts,
    page,
    is3COrder,
    linkCustomAnalyticsData,
    linkAnalyticsData = ``,
    trackingLinkAnalyticsData = "",
    email = "",
    showRadio,
    isAlert,
    isCartPage,
    isHideItemPrice,
    cartItems,
    errors,
    childMode,
    mode = "",
    showBundleModal,
    inventoryData = {},
    setCartQtyLoad,
    lineItemsData = [],
    newLineItemsData = [],
    inventoryCheckLoading,
    handleSelection,
    setLoadingText,
  } = props

  const {
    quantity = 0,
    discountPrice = 0,
    unitPrice = 0,
    bundleMRPPrice = 0,
    totalPrice = 0,
    category = "",
    slug = "",
    sku = "",
    isBundleParent = false,
    id,
    isSelected = false,
  } = data
  const [prodQuantity, setProdQuantity] = useState(data.quantity)
  const [alert, setAlert] = useState({ show: false, mssg: "" })
  const [currencySign, setCurrencySign] = useState("")
  const [productAria, setProductAria] = useState("")
  const [partsModal, setPartsModal] = useState(false)
  const siteName = useRef(null)
  const [action, setAction] = useState("remove")
  const [installServiceData, setInstallServiceData] = useState({})
  const [hasInstallService, setHasInstallService] = useState(false)
  const [error, setError] = useState({})
  const [showChilds, setShowChilds] = useState(false)
  const [etaIndividual, setEtaIndividual] = useState({})

  const dispatch = useDispatch()

  const [pdpNavigationURL, setPdpNavigationURL] = useState("")

  const INSTALL_SERVICES_CATEGORY = "Install Services"
  const CHECKOUT_PAGE = "checkout"
  useEffect(() => {
    const {
      nonDeliverableData = [],
      outOfStockData = [],
      installationServiceData = [],
    } = inventoryData
    let isError = false
    let msg
    if (
      errors ||
      nonDeliverableData?.length ||
      outOfStockData?.length ||
      installationServiceData?.length
    ) {
      if (isBundleParent && data?.bundleItems?.length) {
        const isErrorInBundle = []
        data?.bundleItems.forEach(item => {
          if (Object.keys(errors).includes(item?.sku)) {
            isErrorInBundle.push({ item: item.sku, isError: true })
          }
        })
        if (isErrorInBundle.length) {
          isError = true
          if (isErrorInBundle.length === data?.bundleItems.length) {
            msg = i18n.bundleOutOfStock
          } else {
            msg = i18n.partialBundleOutOfStock
          }
        }
      } else {
        isError = Object.keys(errors).includes(data?.sku)
        const quantity = errors[data?.sku]
        if (quantity > 0) {
          msg = i18n.maxStock(quantity)
        } else {
          const status = getInventoryStatus(data, inventoryData)
          if (status) {
            isError = true
            msg = getInventoryErrorMessage(status, i18n)
          }
        }
      }
      setError({
        isError,
        msg,
      })
    }
  }, [errors, inventoryData])

  useEffect(() => {
    if (!(qtyLoading || loading)) {
      setProdQuantity(data.quantity)
    }
    getPDPUrl(category, slug).then(ret => {
      let pdpUrl = ret
      if (sku) {
        if (pdpUrl.indexOf("?") > -1) {
          pdpUrl = pdpUrl + "&skuId=" + sku
        } else {
          pdpUrl = pdpUrl + "?skuId=" + sku
        }
      }
      setPdpNavigationURL(pdpUrl)
    })

    const isInstallService = isBundleParent
      ? data.bundleItems.filter(item => item.category === "Install Services")
          .length
      : data?.custom?.fields.hasOwnProperty("associatedService")

    setHasInstallService(isInstallService)
    const installServiceName =
      isInstallService && data?.custom?.fields?.associatedService
    const tempInstallServiceData = isBundleParent
      ? data.bundleItems.find(item => item.category === "Install Services")
      : cartItems?.find(
          item =>
            item.sku === installServiceName &&
            item?.custom?.fields?.associatedProduct === data?.sku
        )
    setInstallServiceData(tempInstallServiceData)
  }, [data])

  useEffect(() => {
    if (!(qtyLoading || loading)) {
      setProdQuantity(data.quantity)
    }
  }, [qtyLoading, loading])
  useEffect(() => {
    getConfig().then(config => {
      const currency = _get(config, "internationalization.currencySign", "")
      setCurrencySign(currency)
      siteName.current = _get(config, "general.siteName", "")
    })
  }, [])

  useEffect(() => {
    if (checkoutMode) {
      const etaData = getEtaDataIndividual(
        lineItemsData,
        data,
        newLineItemsData
      )
      setEtaIndividual(etaData)
    }
  }, [lineItemsData])

  useEffect(() => {
    const productAria = `${data.name}. ${data.desc}. ${i18n.colorFinish}: ${
      data.color
    }. ${i18n.qty}: ${quantity}. ${i18n.unitPrice}: ${currencySign}${
      discountPrice > 0 ? discountPrice : unitPrice
    }. ${i18n.total}: ${currencySign}${totalPrice}.`
    setProductAria(productAria)
  }, [data])

  const handleChange = async qty => {
    setProdQuantity(qty)
    setAlert({ show: false, mssg: "" })
    await onQuantityChange(
      data.sku,
      qty,
      isBundleParent,
      data?.masterVariantKey,
      checkStock(data.backOrder, data.category),
      mssg => setAlert({ show: true, mssg }),
      data
    )
  }
  const siteWideCoupanCode = []
  const productCouponCode = []
  const discountPercents = []
  let productCoupondiscount = 0
  let siteWideDiscount = 0
  let newDiscountPercentage = 0

  if (data.discountsList?.length) {
    data.discountsList.forEach(discountItem => {
      if (discountItem.type === "sitewide") {
        // always apply sitewide discount first then remaining can be applied
        siteWideDiscount +=
          Number(data.unitPrice) * (discountItem?.percent / 100)
        siteWideCoupanCode.push(discountItem?.code?.toLowerCase())
      } else {
        // there can be multiple product coupon codes
        discountPercents.push(discountItem?.percent)
        productCouponCode.push(discountItem?.code)
      }
    })
    if (discountPercents.length) {
      let priceAfterDiscount = Number(data?.unitPrice) - siteWideDiscount
      let temporaryCouponPrice
      for (const disc of discountPercents) {
        temporaryCouponPrice = Number(
          (priceAfterDiscount * (disc / 100)).toFixed(2)
        )
        priceAfterDiscount = priceAfterDiscount - temporaryCouponPrice
        productCoupondiscount += temporaryCouponPrice
      }
      productCoupondiscount = Number(productCoupondiscount.toFixed(2))
    }
  } else if (Number(data.totalBasePrice) > Number(data.unitPrice)) {
    newDiscountPercentage =
      ((Number(data.totalBasePrice) - Number(data.unitPrice)) /
        Number(data.totalBasePrice)) *
      100
    newDiscountPercentage = Number(newDiscountPercentage.toFixed(2))
  }
  const MRPPrice = data?.prices?.find(price => !price.customerGroup) ?? {}
  const basePrice = Number(data?.totalBasePrice)
  const salePrice = data?.discountPrice
    ? Number(data?.discountPrice)
    : Number(data?.unitPrice)
  const discountedAmt = basePrice - Number(salePrice)
  const cartItemProductInfo =
    linkCustomAnalyticsData ??
    data.customProductInfo ??
    JSON.stringify({
      productInfo: {
        productBrand: siteName?.current?.toLowerCase(),
        description: sanitizeTextForAnalytics(data.desc),
        globalDiscount: discountedAmt,
        globalPromotionPrice: Number(salePrice),
        itemType: data?.category || data?.businessUnitName || "",
        globalOffer: siteWideCoupanCode?.join("|") || "n/a",
        productCouponCode: productCouponCode?.join("|") || "n/a",
        priceState:
          data?.discountPercent > 0 || data?.discountAmount > 0
            ? "percentOff|" + data?.discountPercent
            : newDiscountPercentage > 0
            ? "percentOff|" + newDiscountPercentage
            : "regular price",
        productBasePrice: Number(basePrice),
        productCategory: sanitizeTextForAnalytics(data?.category),
        productColor: sanitizeTextForAnalytics(data?.color),
        productID: data?.customerFacingSKU || data?.sku,
        productName: sanitizeTextForAnalytics(data?.name),
        productRoom: sanitizeTextForAnalytics(data?.category),
        productSalePrice: Number(salePrice),
        productStatus:
          data.outOfStock && data.availableQty < 1
            ? "out of stock"
            : "in stock",
        productSuperSku: data.superSku ? true : false,
        productTileName: sanitizeTextForAnalytics(data.name),
        quantity: data.quantity,
        defaultImageName: data.image || "n/a",
        productCollectionsName: sanitizeTextForAnalytics(
          data?.productCollectionsName || data?.category
        ),
        productCoupondiscount: productCoupondiscount || 0,
        productPartnerBuyNow: true,
        productSaleable: true,
        isRecommended: true,
        isSubscription: true,
        frequency: "n/a",
        ratings: "n/a",
        numberOfReviews: 0,
        pdpType: pdpTypeFormat({
          businessUnitName: data.businessUnitName,
          ProductIsRetail: data.ProductIsRetail,
          discontinuedProductb: data.discontinuedProductb,
          ProductRequiredAccessoriesGroupsList:
            data.ProductRequiredAccessoriesGroupsList,
          superSku: data.superSku,
        }),
        productFindingMethod: "n/a",
      },
    })

  const getTrackingLinkAnalyticsData = link => {
    return trackingLinkAnalyticsData
      ? JSON.stringify({
          eventAction: "my account:orders:order details:tracking link",
          eventName: "my account:orders:order details:tracking link",
          eventType: "navigation",
          eventMsg: "n/a",
          eventStatus: "n/a",
          internalLinkName: "tracking link",
          internalLinkPosition: "order history",
          internalLinkType: "my account:navigation",
          internalLinkZoneName: "my account:orders:order details",
          internalLinkURL: link
            ? (link.indexOf("http") === -1 ? window.location.origin : "") + link
            : "n/a",
          clickInternalLinks: "true",
        })
      : null
  }

  const isMsgStatus = getMessageStatus({
    data,
    email,
    hideAlerts,
    i18n,
    checkoutMode,
  })
  const isMsgMobileStatus = getMessageStatus({
    data,
    email,
    hideAlerts,
    i18n,
    isMobile: true,
    alert,
  })

  const isKVAPPromoApplied = () => {
    return Boolean(
      data.discountsList?.find(item => item.code.startsWith("KAS"))
    )
  }

  return (
    <>
      {comboChild && (
        <div className="cart-item__item-of">
          {i18n.itemOf(comboChild.index, comboChild.count)}
        </div>
      )}
      <div
        className={`row cart-item no-gutters ${
          childMode ? "cart-item__child px-0 m-0" : ""
        }`}
      >
        {partsModal && (
          <PartsViewer
            page="cart"
            i18n={i18n}
            productId={data.svgProductId}
            showModal={partsModal}
            partId={data.svgId}
            onClose={() => setPartsModal(false)}
            analyticsCustomData={cartItemProductInfo}
          />
        )}
        <div
          className={`col-12 col-sm-6 mobile-full-width pl-0 ${
            page === CHECKOUT_PAGE
              ? "col-md-11"
              : isDeliveryOption || isAlert || orderMode
              ? "col-md-8"
              : "col-md-6"
          } print-left ${
            comboChild && orderMode
              ? `cart-item__combo-item col-md-6`
              : comboChild
              ? "cart-item__combo-item col-md-12"
              : ""
          }`}
        >
          <div className="cart-item__summary">
            {!checkoutMode && !childMode && (
              <div className="select">
                <Checkbox
                  onChange={e => handleSelection(id, e.target.checked)}
                  checked={isSelected}
                  value=""
                />
              </div>
            )}
            <a
              role="button"
              className="gbh-data-layer"
              tabIndex={0}
              onClick={() => {
                deliveryOverlayEventInfoAnalytics(
                  pdpNavigationURL,
                  data,
                  JSON.parse(cartItemProductInfo).productInfo
                )
              }}
            >
              {page === CHECKOUT_PAGE &&
              data.category === INSTALL_SERVICES_CATEGORY ? (
                <div className="install-service-icon">
                  <img src={CartServiceIcon.src} alt="Installation Service" />
                </div>
              ) : (
                <span className="img-wrapper">
                  <Image
                    className="cart-item__image"
                    src={data.image ?? noImage?.src}
                    alt={data.name}
                    area-label={data.name}
                    width={200}
                    height={200}
                    aria-description="image of product"
                    //  onError={e => (e.target.src = noImage?.src)}
                  />
                </span>
              )}
            </a>
            <section className="cart-item__specs">
              <div className="cart-item__brand">
                <span className="cart-item__brand-name">KOHLER</span>
              </div>
              {!comboChild && (
                <a
                  href={pdpNavigationURL}
                  onClick={() => {
                    deliveryOverlayEventInfoAnalytics(
                      pdpNavigationURL,
                      data,
                      JSON.parse(cartItemProductInfo).productInfo
                    )
                  }}
                  tabIndex={0}
                  aria-description={productAria}
                >
                  <span className="cart-item__name">
                    {data.name && data.category !== INSTALL_SERVICES
                      ? data.name
                      : childMode
                      ? `Installation Service For SKU ${data?.custom?.fields?.parentBundleSku}`
                      : `Installation Service For SKU ${data?.custom?.fields?.associatedProduct}`}
                  </span>
                </a>
              )}
              {data.desc && <p className="cart-item__desc">{data.desc}</p>}
              {data.category !== "Install Services" &&
                data.category !== "Design Services" &&
                data.color !== "Not Applicable" &&
                !isBundleParent &&
                !comboChild && (
                  <p className="cart-item__color">
                    {i18n.colorFinish}: {data.color}
                  </p>
                )}
              {isBundleParent && (
                <div className="cart-item__bundle-items">
                  {`${getChildItemsCount(data.bundleItems)} ${i18n.items} ${
                    !checkoutMode || mode === "share" ? "| " : ""
                  }`}
                  {(!checkoutMode || mode === "share") && (
                    <button onClick={() => setShowChilds(!showChilds)}>
                      {showChilds ? i18n.hideMore : i18n.showMore}
                    </button>
                  )}
                </div>
              )}
              <div
                className={`${
                  isBundleParent ? "cart-item-bundle__sku" : ""
                } cart-item__sku mt-5`}
              >
                {i18n.sku}:{" "}
                {data?.custom?.fields?.associatedProduct && !checkoutMode
                  ? data?.custom?.fields?.associatedProduct
                  : data.customerFacingSKU || data.sku}
              </div>
              {isKVAPPromoApplied() ? (
                <div className="cart-item__promo-applied">
                  Promo code applied
                </div>
              ) : null}
              {!isBundleParent && mode !== "delivery" && (
                <div className="cart-item__mrp mt-10">
                  <span>MRP: </span>
                  <NumericFormat
                    className=""
                    value={Number(MRPPrice.value.centAmount / 100).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    thousandsGroupStyle={"lakh"}
                    prefix={currencySign}
                    decimalScale={2}
                  />
                </div>
              )}
              {isBundleParent && mode !== "delivery" && (
                <div className="cart-item__mrp mt-10">
                  <span>MRP: </span>
                  <NumericFormat
                    className=""
                    value={Number(bundleMRPPrice / 100).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    thousandsGroupStyle={"lakh"}
                    prefix={currencySign}
                    decimalScale={2}
                  />
                </div>
              )}
              {isBundleParent && (
                <div className="cart-item__bundle-badge">{i18n.bundle}</div>
              )}
              {!checkoutMode &&
                data.isComboSku &&
                !isDeliveryOption &&
                !orderMode && (
                  <p className="cart-item__note --mobile">
                    {i18n.note}: {i18n.comboSkuMssg}
                  </p>
                )}
              {email && (
                <p className="d-block d-lg-none cart-item__email">
                  {i18n.email}: {email}
                </p>
              )}
              {email &&
                (data.category === "Install Services" ||
                  data.category === "Design Services") && (
                  <p className="cart-item__note --e-delivery">
                    {i18n.note}:{" "}
                    {data.category === "Install Services"
                      ? i18n.eDeliveryMsg
                      : i18n.eDeliveryNote}
                  </p>
                )}
              {(isDeliveryOption ? !comboChild : false) && (
                <p
                  className={`cart-item__${
                    checkoutMode ? "qty_label" : "quantity-price"
                  }`}
                >
                  <span className="cart-item__label --count">
                    <span> {i18n.cartItemTileQty} : </span>
                    {`${data.quantity}`}
                  </span>
                  {mode !== "delivery" ? (
                    <span className="cart-item__label --sum">
                      <NumericFormat
                        value={data.totalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={currencySign}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandsGroupStyle={"lakh"}
                      />
                    </span>
                  ) : null}
                </p>
              )}
              {!isDeliveryOption && !isCartPage && data.discountPrice > 0 && (
                <div className="cart-item__display-discount --mobile">
                  <div className="cart-item__discount-price --offPercentage ">
                    <span>
                      {data.discountPercent
                        ? `${data.discountPercent}${i18n.discountPercentage}`
                        : data.discountAmount
                        ? `${currencySign}${data.discountAmount} ${i18n.off}`
                        : ""}
                    </span>
                  </div>
                  <div className="cart-item__discount-price --mobile">
                    <NumericFormat
                      value={data.unitPrice * data.quantity}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandsGroupStyle={"lakh"}
                    />
                  </div>
                </div>
              )}
              {(checkoutMode || orderMode) && comboChild ? (
                <p
                  className="cart-item__qty_label"
                  aria-description={i18n.quantity}
                >
                  {`${i18n.cartItemTileQty} :  ${data.quantity} `}
                </p>
              ) : null}
              {checkoutMode && data.category !== INSTALL_SERVICES ? (
                inventoryCheckLoading ? (
                  <div>
                    <div className="loading-spinner"></div>
                    Calculating delivery timelines
                  </div>
                ) : (
                  <div>
                    {i18n?.etaInformation &&
                      !etaIndividual.isError &&
                      i18n?.etaInformation(
                        etaIndividual.minDay,
                        etaIndividual.maxDay
                      )}
                    <div />
                  </div>
                )
              ) : (
                ""
              )}
              {orderMode && !isHideItemPrice ? (
                <p className="order-complete-item-price">
                  {i18n.itemPrice}:{" "}
                  <NumericFormat
                    value={
                      Number(data.discountPrice)
                        ? data.discountPrice
                        : data.unitPrice
                    }
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandsGroupStyle={"lakh"}
                  />{" "}
                  {Number(data.discountPrice) ? (
                    <NumericFormat
                      className="cart-item__span"
                      value={data.unitPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={currencySign}
                      decimalScale={2}
                      thousandsGroupStyle={"lakh"}
                    />
                  ) : null}
                </p>
              ) : null}
            </section>
          </div>
        </div>
        {isMsgMobileStatus ? (
          <div className="cart-stock-message-mobile">
            <div className="cart-item__qty-mobile">&nbsp;</div>
            {data.cancelled && (
              <div className="row">
                <div className="col text-right cart-item__stock-msg">
                  {i18n.cancelled}
                </div>
              </div>
            )}
            {email && (
              <div className="row">
                <span className="col d-none d-lg-block text-right cart-item__stock-msg">
                  {i18n.email} : {email}
                </span>
              </div>
            )}
            {!hideAlerts && (
              <>
                {error?.isError && (
                  <div className="col cart-item__stock-msg --error">
                    <span>{error?.msg}</span>
                  </div>
                )}
                {alert.show && (
                  <div className="col cart-item__stock-msg --error">
                    <span>{alert.mssg}</span>
                  </div>
                )}

                {/* {!alert.show && data.outOfStock && data.availableQty < 1 && (
                  <div className="col text-right cart-item__stock-msg --error">
                    <span>{i18n.outOfStock}</span>
                  </div>
                )} */}

                {/* {!alert.show && data.outOfStock && data.availableQty > 0 && (
                  <div className="col cart-item__stock-msg --error">
                    <span>
                      {i18n.qtyMoreThanStock(data.availableQty, data.quantity)}
                    </span>
                  </div>
                )} */}

                {!alert.show && !data.outOfStock && data.noShipping && (
                  <div className="col cart-item__stock-msg --error">
                    <span>{i18n.cannotShip}</span>
                  </div>
                )}
              </>
            )}
            {!hideAlerts &&
              data.category !== "Install Services" &&
              data.category !== "Design Services" && (
                <>
                  {data.backOrder &&
                  data.leadTime &&
                  data.quantity > data.availableQty ? (
                    <p className="cart-item__stock-msg">
                      {i18n.backOrderMssg(data.leadTime)}
                    </p>
                  ) : (
                    !alert.show && (
                      <p className="cart-item__stock-msg">
                        {data.outOfStock || data.noShipping ? "" : i18n.inStock}
                      </p>
                    )
                  )}
                </>
              )}
            {!data.cancelled &&
              hideAlerts &&
              data.backOrder &&
              data.leadTime &&
              data.quantity > data.availableQty &&
              i18n.backOrderMssg && (
                <>
                  <p className="cart-item__stock-msg">
                    {i18n.backOrderMssg(data.leadTime)}
                  </p>
                </>
              )}
          </div>
        ) : null}

        <div
          className={`col-12 col-sm-6 ${
            isDeliveryOption || orderMode
              ? "col-md-4"
              : isAlert
              ? "col-md-4"
              : "col-md-6"
          } cart-item__info print-right pr-0`}
        >
          <div className="row cart-item__qty-price cart-qty-price-mobile mx-0 px-0">
            <div className="cart-item__qty-mobile">&nbsp;</div>
            {!isAlert && !isDeliveryOption && !orderMode ? (
              <div
                className={`${
                  orderMode ? "col-6" : "col-5"
                }  cart-item__discount-container discount-container-padding`}
              >
                {!is3COrder && (
                  <>
                    <div className="cart-item__price">
                      <NumericFormat
                        className="cart-item__total-price hide-mobile-price"
                        aria-description={i18n.unitPrice}
                        value={
                          data.discountPrice > 0
                            ? data.discountPrice
                            : data.unitPrice
                        }
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={currencySign}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandsGroupStyle={"lakh"}
                      />
                      {(isDeliveryOption ? !comboChild : true) && (
                        <div
                          className={`${isDeliveryOption ? "col-6" : "col-2"} ${
                            isBundleParent ? "cart-item-bundle__total" : ""
                          } text-right cart-item__total px-0 mobile-total-price`}
                        >
                          <NumericFormat
                            className="cart-item__total-price "
                            aria-description={i18n.total}
                            value={data.totalPrice}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={currencySign}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            thousandsGroupStyle={"lakh"}
                          />{" "}
                        </div>
                      )}
                      <br className="show-mobile" />
                      {/* {data.category !== "Install Services" &&
                        data.discountPrice > 0 && (
                          <div className="cart-item__span  car-total-qty-mobile">
                            <NumericFormat
                              className=""
                              value={data.unitPrice * quantity}
                              displayType={"text"}
                              thousandSeparator={true}
                              thousandsGroupStyle={"lakh"}
                              prefix={currencySign}
                              decimalScale={2}
                            />
                          </div>
                        )} */}
                    </div>
                  </>
                )}
              </div>
            ) : null}
            <div
              className={`${
                isDeliveryOption || isAlert
                  ? "col-6"
                  : orderMode
                  ? "col-6"
                  : mode === "share"
                  ? "col-2"
                  : "col-3"
              } cart-item__qty px-0 ${data.discountPrice ? "-mt-24" : ""}`}
            >
              {!checkoutMode ? (
                <QuantitySelector
                  size="small"
                  value={prodQuantity}
                  onChange={qty => handleChange(qty)}
                  loading={qtyLoading || loading}
                  productData={data}
                  source="cart-landing"
                  readOnly={childMode}
                  setQuantity={setProdQuantity}
                />
              ) : null}
              {mode === "share" && (
                <p
                  className={`cart-item__${
                    checkoutMode ? "qty_label" : "quantity-price"
                  }`}
                >
                  <span className="--count">{`${data.quantity}`}</span>
                </p>
              )}
            </div>
            {
              <>
                {(!checkoutMode || mode === "share") &&
                  (isDeliveryOption ? !comboChild : true) && (
                    <div
                      className={`${
                        isDeliveryOption || isAlert || orderMode
                          ? "col-6"
                          : "col-4"
                      } text-right cart-item__total px-0 hide-price-popup-mobile`}
                    >
                      <NumericFormat
                        className="cart-item__total-price  hide-mobile-price"
                        aria-description={i18n.total}
                        value={data.totalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={currencySign}
                        decimalScale={2}
                        thousandsGroupStyle={"lakh"}
                        fixedDecimalScale={true}
                      />
                      {data.category !== "Install Services" &&
                        data.discountPrice > 0 &&
                        !childMode && (
                          <div className="cart-item-qty-container">
                            {/* <span>MRP</span> */}
                            <NumericFormat
                              className="cart-item__span  car-total-qty-desktop"
                              value={(data.unitPrice * data.quantity).toFixed(
                                2
                              )}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={currencySign}
                              decimalScale={2}
                              thousandsGroupStyle={"lakh"}
                            />
                          </div>
                        )}
                      {data.category !== "Install Services" &&
                        !orderMode &&
                        data.discountPrice > 0 && (
                          <div
                            className={
                              orderMode
                                ? "cart-item__display-discount-order"
                                : !checkoutMode
                                ? "cart-item__display-discount-cart"
                                : "cart-item__display-discount"
                            }
                            aria-label={`Striked price`}
                            aria-required="true"
                            aria-invalid="false"
                          >
                            <div
                              className={
                                orderMode
                                  ? "cart-item__discount-price --offPercentage"
                                  : !checkoutMode
                                  ? "cart-item__discount-price --offPercentCart"
                                  : "cart-item__discount-price --offPercent"
                              }
                            >
                              <span>
                                {data.discountPercent && !childMode
                                  ? `${data.discountPercent}${i18n.discountPercentage}`
                                  : data.discountAmount
                                  ? `${currencySign}${data.discountAmount} ${i18n.off}`
                                  : ""}
                              </span>
                            </div>
                            {/* <NumericFormat
                              className="cart-item__span"
                              value={data.unitPrice}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={currencySign}
                              decimalScale={2}
                            /> */}
                          </div>
                        )}
                    </div>
                  )}
              </>
            }
            <div className="clear"></div>
          </div>
          {(data.trackingLinks || data.svgId) && (
            <div className="cart-item__links">
              {data.trackingLinks?.map((link, i) => {
                return (
                  <>
                    {data.availableQty ? (
                      <div key={i} className="cart-item__link">
                        <a
                          href={link.trackingURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={
                            trackingLinkAnalyticsData ? "gbh-data-layer" : ""
                          }
                          data-gbh-data-layer={
                            trackingLinkAnalyticsData
                              ? getTrackingLinkAnalyticsData(link.trackingURL)
                              : null
                          }
                          data-gbh-data-layer-custom={cartItemProductInfo}
                        >
                          {i18n.tracking}: {link.trackingId}
                        </a>
                      </div>
                    ) : null}
                  </>
                )
              })}
              {data.svgId && (
                <div className="cart-item__link">
                  <span
                    className={linkAnalyticsData ? "gbh-data-layer" : ""}
                    role="link"
                    tabIndex="0"
                    data-gbh-data-layer={linkAnalyticsData || null}
                    data-gbh-data-layer-custom={cartItemProductInfo}
                    onClick={() => setPartsModal(true)}
                  >
                    {i18n.viewPartsDiagram}
                  </span>
                </div>
              )}
            </div>
          )}

          {showRadio && (
            <div className="cart-item__radio-group">
              <Radio
                value="remove"
                checked={action === "remove"}
                type="black"
                label={i18n.remove}
                name={`kf-shipping-alert-${data.sku}`}
                onSelect={e => setAction(e.target.value)}
              />
            </div>
          )}
        </div>
        {isMsgStatus ? (
          <div
            className={`${
              orderMode && email
                ? "order-mode-hide-main-section"
                : "col-12 px-0"
            }`}
            id={`${error?.isError ? `scroll-error-${data.id}` : ""}`}
          >
            <div className="cart-item__cta-wrapper hide-mobile-checkout-section">
              <div className="cart-blank-section">&nbsp;</div>
              <div className="cart-stock-msg desktop-cart-stock-msg">
                {data.cancelled && (
                  <div className="row">
                    <div className="col text-right cart-item__stock-msg">
                      {i18n.cancelled}
                    </div>
                  </div>
                )}
                {email && (
                  <div className={`${orderMode ? "order-mode-hide" : "row"}`}>
                    <span className="cart-item__stock-msg">
                      {i18n.email} : {email}
                    </span>
                  </div>
                )}
                {!hideAlerts && (
                  <div className="row">
                    {error?.isError && (
                      <div className="col cart-item__stock-msg --error">
                        <span>{error?.msg}</span>
                      </div>
                    )}
                    {alert.show && (
                      <div className="col cart-item__stock-msg --error">
                        <span>{alert.mssg}</span>
                      </div>
                    )}

                    {/* {!alert.show &&
                      data.outOfStock &&
                      data.availableQty < 1 && (
                        <div className="col text-right cart-item__stock-msg --error">
                          <span>{i18n.outOfStock}</span>
                        </div>
                      )} */}

                    {/* {!alert.show &&
                      data.outOfStock &&
                      data.availableQty > 0 && (
                        <div className="col cart-item__stock-msg --error">
                          <span>
                            {i18n.qtyMoreThanStock(
                              data.availableQty,
                              data.quantity
                            )}
                          </span>
                        </div>
                      )} */}
                    {!alert.show && !data.outOfStock && data.noShipping && (
                      <div className="col cart-item__stock-msg --error">
                        <span>{i18n.cannotShip}</span>
                      </div>
                    )}
                  </div>
                )}
                {!hideAlerts &&
                  data.category !== "Install Services" &&
                  data.category !== "Design Services" && (
                    <>
                      {data.backOrder &&
                      data.leadTime &&
                      data.quantity > data.availableQty ? (
                        <p className="cart-item__stock-msg">
                          {i18n.backOrderMssg(data.leadTime)}
                        </p>
                      ) : (
                        !alert.show &&
                        !error?.isError && (
                          <>
                            <p className="cart-item__stock-msg">
                              {data.outOfStock || data.noShipping
                                ? ""
                                : i18n.inStock}
                            </p>
                            {data.leadTime ? (
                              <p className="cart-item__stock-msg">
                                {i18n.backOrderMssg(data.leadTime)}
                              </p>
                            ) : null}
                          </>
                        )
                      )}
                    </>
                  )}
                {!data.cancelled &&
                  hideAlerts &&
                  data.backOrder &&
                  data.leadTime &&
                  data.quantity > data.availableQty &&
                  i18n.backOrderMssg && (
                    <>
                      <p className="cart-item__stock-msg">
                        {i18n.backOrderMssg(data.leadTime)}
                      </p>
                    </>
                  )}
              </div>
              {!checkoutMode && (
                <div className="remove-sec-cart">
                  <div
                    className={`cart-item__cta ${loading ? "--loading" : ""}`}
                    onClick={() =>
                      addRemoveProductFromCartAnalytics("cmp:click", data)
                    }
                    data-gbh-data-layer-custom={cartItemProductInfo}
                  >
                    <span
                      tabIndex="0"
                      role="button"
                      aria-label={`${data.name} ${i18n.remove}`}
                      onClick={() => {
                        if (childMode && data.category !== "Install Services") {
                          showBundleModal(id)
                        } else {
                          removeCartItem(
                            data,
                            null,
                            isBundleParent,
                            setCartQtyLoad,
                            setLoadingText
                          )
                          dispatch(setCardStatus(true))
                        }
                      }}
                    >
                      Remove
                    </span>
                  </div>
                </div>
              )}
              <div className="clear"></div>
            </div>
          </div>
        ) : null}

        {isBundleParent && (
          <div
            className={`child-items__wrapper p-0 ${
              showChilds ? "open" : "close"
            }`}
          >
            <div className="child-items__inner">
              {data.bundleItems
                .filter(item => item.category !== "Install Services")
                .map(item => (
                  <CartItemTile
                    key={item.id}
                    i18n={i18n}
                    loading={loading}
                    {...props}
                    data={item}
                    checkoutMode={checkoutMode}
                    cartItems={cartItems}
                    errors={errors}
                    childMode={true}
                    setLoadingText={setLoadingText}
                  />
                ))}
            </div>
          </div>
        )}

        {(hasInstallService &&
          installServiceData &&
          data?.custom?.fields?.associatedServiceQty > 0) ||
        (isBundleParent && hasInstallService) ? (
          <InstallationServiceCart
            key={installServiceData?.id}
            i18n={i18n}
            loading={loading}
            checkoutMode={checkoutMode}
            data={installServiceData}
            productData={data}
            productQuantity={quantity}
            onQuantityChange={onQuantityChange}
            currencySign={currencySign}
            orderMode={orderMode}
            mode={mode}
            inventoryData={inventoryData}
          />
        ) : null}
      </div>
    </>
  )
}

export default CartItemTile
